import React, { useState, useEffect, useContext, useRef } from "react"
import { Button, message, Dropdown, Flex, Input } from "antd"
import { UserContext, useUser } from "../../contexts/UserContext"
import { useTranslation } from "react-i18next"
import { createNewOrganization } from "../../api/Cards/users"

const Organization = ({ messageApi }) => {
    const { t } = useTranslation()
    const { user } = useContext(UserContext)
    const { getToken, isAdmin, getRole } = useUser()
    const orgData = useRef({})
    const [errorFields, setErrorFields] = useState(false)

    function getStatus(value) {
        if (errorFields && !value)
            return "error"
        return ""
    }

    function submitNewOrganization() {

        if (
            !orgData.current.OrganizationName ||
            !orgData.current.Address ||
            !orgData.current.Phone
        ) {
            setErrorFields(true)
            return;
        }

        setErrorFields(false)

        async function createOrg() {

            var newOrganization = { Token: user.token, ...orgData.current }
            const data = await createNewOrganization(newOrganization)
            
            if (typeof data == "number" && data != 200) {
                if (data == 401)
                    messageApi.error("Unauthorized")
                else if (data == 409)
                    messageApi.error(t('page.newaccount.ofield.exists'))
                else
                    messageApi.error("Internt fel uppstod")
                return
            }

            messageApi.success(t('page.newaccount.ofield.new'))

        }
        createOrg();
    }

    return (
        <>
            <div style={{ width: "300px" }} >
                <Input style={{ marginTop: "10px" }} status={getStatus(orgData.current.OrganizationName)} size="large" onChange={(e) => { orgData.current.OrganizationName = e.target.value }} placeholder={t('page.newaccount.ofield.name')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(orgData.current.Address)} size="large" onChange={(e) => { orgData.current.Address = e.target.value }} placeholder={t('page.editaccount.adress')} ></Input>
                <Input style={{ marginTop: "10px" }} status={getStatus(orgData.current.Phone)} size="large" onChange={(e) => { orgData.current.Phone = e.target.value }} placeholder={t('page.editaccount.phone')} ></Input>
                <Button style={{ marginTop: "50px", width: "100%" }} type="primary" onClick={submitNewOrganization}>{t('page.newaccount.ofield.create')}</Button>
            </div>
        </>
    )
}

export default Organization